const USE_PRODUCTS_SITE_URLS_CONSTANTS = Object.freeze({
  ROUTES: Object.freeze({
    DASHBOARD: '/dashboard',
  }),
});

export { USE_PRODUCTS_SITE_URLS_CONSTANTS };
